import { Component } from '@angular/core';

@Component({
    selector: 'field-app-download',
    templateUrl: './field-app-sownload.component.html',
    styleUrls: ['./field-app-download.component.styles.scss']
})
export class FieldAppDownload {}
